"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Action = function Action() {
    var _this = this;

    var actionData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, _classCallCheck3.default)(this, Action);
    this.type = "";
    this.payload = {};
    this.keyPath = [];

    this._unget = function (key) {
        var type = _this.type,
            payload = _this.payload,
            keyPath = _this.keyPath;

        return new Action({
            type: type,
            payload: payload,
            keyPath: [key].concat((0, _toConsumableArray3.default)(keyPath))
        });
    };

    this.shouldBeSynchronous = function () {
        return _this.type === "ping";
    };

    this.isValueAction = function () {
        return _this.type !== "ping" && _this.type !== "setMeta";
    };

    this.isMetaAction = function () {
        return _this.type === "setMeta";
    };

    this.toJS = function () {
        var type = _this.type,
            payload = _this.payload,
            keyPath = _this.keyPath;

        return { type: type, payload: payload, keyPath: keyPath };
    };

    this.type = actionData.type || this.type;
    this.payload = actionData.payload || this.payload;
    this.keyPath = actionData.keyPath || this.keyPath;
};

exports.default = Action;


//////////////////
// WEBPACK FOOTER
// ./~/parcels/lib/change/Action.js
// module id = 181
// module chunks = 35783957827783